import clsx from 'clsx'

import {
  Button,
  CheckIcon,
  Image,
  List,
  UpgradeDialog,
} from '@buffer-mono/popcorn'

import { TrackRender } from '~publish/hooks/tracking/useTrackComponentRendered'

import { Limits } from '../../constants'

import styles from './FreeFeedsLimitReachedDialog.module.css'

import type { JSX } from 'react'

type FreeFeedsLimitReachedDialogProps = {
  enabled?: boolean
  className?: string
  children?: JSX.Element
  open?: boolean
  onUpgrade?: () => void
  onOpenChange?: (open: boolean) => void
}

export const FreeFeedsLimitReachedDialog = ({
  enabled,
  className,
  children,
  open,
  onOpenChange,
  onUpgrade,
}: FreeFeedsLimitReachedDialogProps): JSX.Element | null => {
  if (!enabled) {
    return children ?? null
  }

  return (
    <UpgradeDialog
      key="feedsUpgradeDialog"
      open={open}
      onOpenChange={onOpenChange}
    >
      {/* asChild needs to be false to support multiple conditional dialogs around one trigger */}
      {children && (
        <UpgradeDialog.Trigger
          asChild={false}
          className={clsx(styles.trigger, className)}
        >
          {children}
        </UpgradeDialog.Trigger>
      )}
      <UpgradeDialog.Content>
        <UpgradeDialog.TextContent>
          <TrackRender componentName="FreeFeedsLimitReachedDialog" />
          <UpgradeDialog.Title>Upgrade to add more feeds</UpgradeDialog.Title>
          You&apos;ve reached your limit of {Limits.feeds.free.total} feeds.
          Upgrade your plan to keep adding feeds and so much more.
          <List>
            <List.Item icon={CheckIcon}>
              Schedule up to 2000 posts at a time.
            </List.Item>
            <List.Item icon={CheckIcon}>
              Advanced publishing and planning features.
            </List.Item>
            <List.Item icon={CheckIcon}>
              In-depth social analytics and reporting.
            </List.Item>
          </List>
          <UpgradeDialog.Actions>
            <Button size="large" onClick={onUpgrade}>
              See Upgrade Options
            </Button>
          </UpgradeDialog.Actions>
        </UpgradeDialog.TextContent>
        <UpgradeDialog.Image className={styles.imageContainer}>
          <Image
            alt="Content feeds upgrade dialog illustration"
            src="https://buffer-publish.s3.us-east-1.amazonaws.com/images/Upgrade-Feeds/feeds-upgrade_2x.png"
            className={styles.image}
            placeholder="https://buffer-publish.s3.us-east-1.amazonaws.com/images/Upgrade-Feeds/feeds-upgrade.png"
          />
        </UpgradeDialog.Image>
      </UpgradeDialog.Content>
    </UpgradeDialog>
  )
}
